import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLanguage } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faHouse } from '@fortawesome/free-solid-svg-icons'
import { faCreditCard } from '@fortawesome/free-solid-svg-icons'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const missionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (missionRef.current) {
      observer.observe(missionRef.current);
    }

  }, [missionRef]);

  return (
    <div ref={missionRef} className='py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 mid-lg:px-16 lg:px-24 flex flex-col items-center'>
      <div className='w-full flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-12'>
        <img className={`w-full lg:w-1/2 rounded-lg shadow-sm object-cover transition-all duration-700
          ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`}
          src="https://dt7j04u1665qi.cloudfront.net/36-1-small.webp"
          srcSet="
            https://dt7j04u1665qi.cloudfront.net/36-1-small.webp 400w,
            https://dt7j04u1665qi.cloudfront.net/36-1-medium.webp 800w,
            https://dt7j04u1665qi.cloudfront.net/36-1-large.webp 1200w
          "
          sizes="(max-width: 600px) 400px, (max-width: 1200px) 800px, 1200px"
          alt="About Haideries"
        />
        <div className='w-full lg:w-1/2'>
          <h1 className={`text-2xl sm:text-3xl md:text-4xl font-light tracking-wider mb-4 transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'}`}>
            ABOUT HAIDERIES REAL ESTATE
          </h1>
          <p className={`text-xs sm:text-sm md:text-base leading-relaxed text-gray-700 transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
            Haideries is an integrated real estate service provider, ranked UAE’s Number 1 agency in the United Arab Emirates, offering a comprehensive range of services to clients from local and international backgrounds. Unlike conventional real estate companies, Haideries designed a unique framework that focuses on improving clients’ experiences by providing them with appropriate tools, unbiased guidance, and in-depth knowledge about specific locations. Their approach aims to empower clients and ensure their satisfaction throughout the real estate process.
          </p>
          <div className='pt-6 grid grid-cols-2 gap-3 sm:gap-6 my-4'>
            <div className="flex items-center border-b pb-3" style={{ borderColor: "#4B6587" }}>
              <FontAwesomeIcon className='text-2xl sm:text-3xl md:text-4xl text-bluColor flex-shrink-0' icon={faCreditCard} />
              <div className='ml-2 sm:ml-4'>
                <div className='text-sm sm:text-base md:text-lg font-bold'>20 BILLION</div>
                <div className='text-xs text-gray-600'>Total Value</div>
              </div>
            </div>
            <div className="flex items-center border-b pb-3" style={{ borderColor: "#4B6587" }}>
              <FontAwesomeIcon className='text-2xl sm:text-3xl md:text-4xl text-bluColor flex-shrink-0' icon={faLanguage} />
              <div className='ml-2 sm:ml-4'>
                <div className='text-sm sm:text-base md:text-lg font-bold'>20 +</div>
                <div className='text-xs text-gray-600'>Language Spoken</div>
              </div>
            </div>
            <div className="flex items-center border-b pb-3" style={{ borderColor: "#4B6587" }}>
              <FontAwesomeIcon className='text-2xl sm:text-3xl md:text-4xl text-bluColor flex-shrink-0' icon={faUser} />
              <div className='ml-2 sm:ml-4'>
                <div className='text-sm sm:text-base md:text-lg font-bold'>4.9/5</div>
                <div className='text-xs text-gray-600'>Customer Rating</div>
              </div>
            </div>
            <div className="flex items-center border-b pb-3" style={{ borderColor: "#4B6587" }}>
              <FontAwesomeIcon className='text-2xl sm:text-3xl md:text-4xl text-bluColor flex-shrink-0' icon={faHouse} />
              <div className='ml-2 sm:ml-4'>
                <div className='text-sm sm:text-base md:text-lg font-bold'>5000+</div>
                <div className='text-xs text-gray-600'>Properties Sold</div>
              </div>
            </div>
          </div>
          <div className='my-6'>
            <Link to="/WhyHaideries">
              <button className='px-6 sm:px-8 py-3 sm:py-4 border-b-2 font-bold text-bluColor hover:text-white hover:bg-bluColor text-xs sm:text-sm tracking-wider transition-colors' style={{ borderColor: "#4B6587" }}>
                Find Out More <FontAwesomeIcon className='ml-2' icon={faArrowRight} />
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
